
export const siteMain = [
  {
    name: 'site',
    path: '/site',
    icon: 'shezhi',
    component: () => import('/@/views/plugins/site/List.vue'),
    meta: {
      title: '站群列表',
      icon: 'shezhi'
    }
  },
  {
    name: 'siteRegion',
    path: '/site/region/:id',
    icon: 'shezhi',
    component: () => import('/@/views/plugins/site/RegionList.vue'),
    meta: {
      title: '区域列表',
      icon: 'shezhi'
    }
  }
]
